<template>
  <div v-if="show" class="tv-sign">
    <div class="icon">
      <img v-if="result == 1 || result == 2" src="@/assets/image/sign_success.svg" alt="" />
      <img v-else src="@/assets/image/sign_error.svg" alt="" />
    </div>
    <div class="tip">
      {{ result == 1 ? '签到成功' : content }}
    </div>

    <div v-if="result == 1" class="detail">
      <div class="detail-top">
        <div class="user">
          <span style="color: #1a1a1a; font-weight: 500; margin-right: 20px">{{ userName }}</span>
          <span style="color: #4d4d4d">{{ orgName }}</span>
        </div>
        <div class="time">{{ tagTime }}</div>
      </div>
      <div class="detail-bottom">{{ content }}</div>
    </div>

    <div style="padding: 0 60px; margin-top: 160px">
      <van-button @click="back" color="#4A86F6" round block type="primary">知道了</van-button>
    </div>
  </div>
</template>

<script>
import {tvAttendance} from '@/api'
export default {
  data() {
    return {
      show: false,
      // 1.签到成功 2.你已签到 3.本次签到已结束 4.异常 5.未登录
      result: '',
      content: '',

      userName: '',
      orgName: '',
      tagTime: ''
    }
  },
  created() {
    const {p} = this.$route.query
    if (!p) {
      return this.$Toast.fail('签到失败，请重试!')
    }
    const {userInfo} = this.$store.state
    if (!userInfo.id) {
      this.$router.replace(`/login?redirect=${encodeURIComponent(location.href)}`)
      return
    }
    const [code, baseId, overdue] = decodeURIComponent(p).split('|')

    if (code && userInfo.id && overdue && baseId) {
      this.tvSign(code, userInfo.id, overdue, baseId)
    } else {
      this.$Toast.fail('签到失败，请重试!')
    }

    // const {code, objectId, overdue, baseId} = this.$route.query
    // const {userInfo} = this.$store.state
    // if (code && objectId && userInfo.id && overdue && baseId) {
    //   this.tvSign(code, objectId, userInfo.id, overdue, baseId)
    // } else {
    //   this.$Toast.fail('签到失败，请重试!')
    // }
  },
  methods: {
    async tvSign(deviceCode, userId, overdue, baseId) {
      const data = {
        deviceCode,
        userId,
        overdue,
        baseId
      }
      const res = await tvAttendance(data)
      if (res.code === 0) {
        const {result, content, orgName, tagTime, userName} = res.data
        this.result = result
        this.content = content
        this.orgName = orgName
        this.tagTime = tagTime
        this.userName = userName
        this.show = true
      }
    },
    back() {
      this.$router.replace('/')
    }
  }
}
</script>

<style scoped lang="scss">
.tv-sign {
  height: 100vh;
  padding: 28px;
  background: #fff;
}
.icon {
  img {
    width: 60px;
  }
}
.icon,
.tip {
  text-align: center;
}
.tip {
  font-size: 19px;
  font-weight: 500;
  color: #000000;
  margin: 30px 0 40px 0;
}

.detail-top {
  padding: 20px 16px;
  background: #f8f8f8;
  border-radius: 6px;
  .user {
    margin-bottom: 12px;
  }
  .time {
    color: #4d4d4d;
  }
}
.detail-bottom {
  margin-top: 16px;
  color: #808080;
}
</style>
